import { bankServices } from "../../config/axios";
import {
    BANKDISTRICTLIST_SUCCESS,
    BANKDISTRICTLIST_FAILED,
    RESET_BANKDISTRICTLIST,
    LOADING_BANKDISTRICTLIST,
    BANKDISTRICTLIST_NETWORKERROR,
} from '../types/index';

const resetbankDistrictList = () => {
    return { type: RESET_BANKDISTRICTLIST };
};

const bankDistrictList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKDISTRICTLIST });
    await bankServices
        .post("distlist", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: BANKDISTRICTLIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: BANKDISTRICTLIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: BANKDISTRICTLIST_FAILED,
        payload: data
    };
}

export { resetbankDistrictList, bankDistrictList }